const LineupCamIcon = ({ pathFill = 'white' }: { pathFill?: string }) => (
  <svg
    width="19"
    height="14"
    viewBox="0 0 18.9609 13.4053"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="lineup-cam-icon"
  >
    <path
      d="M0.480469 9.44434C0.745565 9.44434 0.960938 9.65971 0.960938 9.9248V12.4443H3.48047C3.74557 12.4443 3.96094 12.6597 3.96094 12.9248C3.96081 13.1898 3.74549 13.4053 3.48047 13.4053H0.480469C0.21545 13.4053 0.000127021 13.1898 0 12.9248V9.9248C0 9.65971 0.215372 9.44434 0.480469 9.44434ZM18.4805 9.4082C18.7455 9.4082 18.9608 9.62369 18.9609 9.88867V12.8887C18.9609 13.1538 18.7456 13.3691 18.4805 13.3691H15.4805C15.2154 13.3691 15 13.1538 15 12.8887C15.0001 12.6237 15.2155 12.4082 15.4805 12.4082H18V9.88867C18.0001 9.62369 18.2155 9.4082 18.4805 9.4082ZM3.48047 0C3.74557 0 3.96094 0.215372 3.96094 0.480469C3.96094 0.745565 3.74557 0.960938 3.48047 0.960938H0.960938V3.48047C0.960938 3.74557 0.745565 3.96094 0.480469 3.96094C0.215372 3.96094 0 3.74557 0 3.48047V0.480469C0 0.215372 0.215372 0 0.480469 0H3.48047ZM18.4805 0C18.7456 0 18.9609 0.215372 18.9609 0.480469V3.48047C18.9609 3.74557 18.7456 3.96094 18.4805 3.96094C18.2154 3.96094 18 3.74557 18 3.48047V0.960938H15.4805C15.2154 0.960937 15 0.745565 15 0.480469C15 0.215372 15.2154 0 15.4805 0H18.4805Z"
      fill={pathFill}
    />
    <path
      d="M2.88047 9.00321C5.63443 7.73011 8.61627 -1.44064 14.7164 3.97938C10.9451 3.58968 11.4004 7.74243 16.0805 9.00438V10.0802H2.88047V9.00321Z"
      fill={pathFill}
    />
  </svg>
);

export default LineupCamIcon;
